"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSubscriptionPlansOutputDtoSchema = exports.getSubscriptionPlansInputDtoSchema = exports.availableSubscriptionPlanDtoSchema = exports.currentSubscriptionPlanDtoSchema = exports.pendingPlanChangeDtoSchema = exports.planDisplayDtoSchema = exports.planBadgeDtoSchema = exports.PLAN_BADGE_VARIANTS = exports.commitRateDtoSchema = exports.commitRateTierDtoSchema = void 0;
const z = __importStar(require("zod"));
exports.commitRateTierDtoSchema = z.object({
    size: z.number().int().positive().optional(),
    price: z.number().int().nonnegative(),
});
exports.commitRateDtoSchema = z.object({
    rateType: z.literal('tiered'),
    tiers: z.array(exports.commitRateTierDtoSchema).min(1),
});
exports.PLAN_BADGE_VARIANTS = ['recommended', 'enterprise'];
exports.planBadgeDtoSchema = z.object({
    label: z.string(),
    variant: z.enum(exports.PLAN_BADGE_VARIANTS),
});
exports.planDisplayDtoSchema = z.object({
    title: z.string(),
    subtitle: z.string(),
    badge: exports.planBadgeDtoSchema.nullable(),
    includes: z.array(z.string()),
});
exports.pendingPlanChangeDtoSchema = z.object({
    effectiveAt: z.string(),
    targetAlias: z.string(),
    scheduledBy: z.enum(['customer', 'enforcement']),
});
exports.currentSubscriptionPlanDtoSchema = z.object({
    contractId: z.string(),
    alias: z.string().nullable(),
    designMonthsMaxCommit: z.string(),
    designMonthsCommitted: z.number().int().nonnegative(),
    isSalesManaged: z.boolean(),
    commitRate: exports.commitRateDtoSchema.nullable(),
    nextChargeAt: z.string().nullable(),
    trialEndsAt: z.string().nullable(),
    pendingPlanChange: exports.pendingPlanChangeDtoSchema.nullable(),
});
exports.availableSubscriptionPlanDtoSchema = exports.planDisplayDtoSchema.extend({
    alias: z.string(),
    designMonthsMaxCommit: z.string(),
    commitRate: exports.commitRateDtoSchema,
    freeTrialDays: z.number().int().nonnegative(),
});
exports.getSubscriptionPlansInputDtoSchema = z.object({
    organizationId: z.string().min(1),
});
exports.getSubscriptionPlansOutputDtoSchema = z.object({
    current: exports.currentSubscriptionPlanDtoSchema,
    available: z.array(exports.availableSubscriptionPlanDtoSchema),
});
//# sourceMappingURL=get-subscription-plans.dto.js.map